/**
 * engine ที่เหลืออยู่ (เดิมมีตัวที่สองด้วย — ถูกถอดออกแล้ว ดู `FORMATS.md` หัวข้อ 6)
 * ห่อ jsQR ด้วยสัญญา `QrEngine` ตรรกะเดียวกับที่เคยเรียกตรงใน `decode.ts` ก่อนแยก interface
 * พฤติกรรมไม่เปลี่ยน
 *
 * jsQR เป็นไลบรารี JS ล้วน ทำงาน synchronous ไม่มีขั้น "โหลด/init" แยกต่างหากแบบ engine ที่ใช้ WASM
 * — exception ที่มันโยนออกมาจึงผูกกับภาพใบนั้นใบเดียวเสมอ (เช่น รูปทรงข้อมูลภายในไม่สอดคล้องกัน
 * จนอ่านต่อไม่ได้) ไม่ใช่สัญญาณว่าตัว engine พังทั้งตัว การกลืนแล้วคืน `null` ที่นี่จึงยังตรงตาม
 * สัญญาใน `types.ts` (คืน null เฉพาะกรณี "ภาพนี้ไม่มี QR") — engine ที่ init แบบ async (เช่น
 * ตัวที่ใช้ WASM) ต้องปล่อย exception ของขั้นโหลดให้หลุดออกไปแทน ดูสัญญาเต็มใน `types.ts`
 */

import jsQR from "jsqr";
import type { QrEngine, QrEngineDecodeOptions } from "./types.js";

function toInversionAttempts(
  invert: QrEngineDecodeOptions["invert"],
): "dontInvert" | "onlyInvert" | "attemptBoth" {
  if (invert === "only") return "onlyInvert";
  if (invert === "both") return "attemptBoth";
  return "dontInvert";
}

export function createJsQrEngine(): QrEngine {
  return {
    async decode(img, opts = {}) {
      let hit: { data: string } | null = null;
      try {
        hit = jsQR(img.data, img.width, img.height, {
          inversionAttempts: toInversionAttempts(opts.invert),
        });
      } catch {
        // ALLOWED-SWALLOW: jsQR ทำงาน synchronous ไม่มีขั้น "engine พังทั้งตัว" แยกจาก
        // "ภาพนี้ไม่มี QR" (ดูเหตุผลเต็มในคอมเมนต์หัวไฟล์) — exception ทุกตัวของมันผูกกับ
        // ภาพใบเดียวเสมอ จึงเทียบเท่า "ไม่พบ QR ในภาพนี้" ตรงตามสัญญาใน `types.ts` จริงๆ
        hit = null;
      }
      return hit && hit.data.length > 0 ? hit.data : null;
    },
  };
}
